export default "__VITE_ASSET__Btv0IM_2__"